import { AccountIcon } from '../Brand/Icon';
import React, { useLayoutEffect, useRef, useState } from "react";
import './index.scss';

function AvatarImage({ picture, loading }) {
    const [status, setStatus] = useState(picture ? 'loading' : 'empty');
    const image = useRef(null);

    useLayoutEffect(() => {
        // Route navigation remounts the footer. A cached avatar is already
        // available before load is delivered: show it before the first paint.
        if (image.current?.complete && image.current.naturalWidth > 0) setStatus('loaded');
    }, []);

    return (
        <span className="avatar-image nav-icon" data-status={status} aria-hidden="true">
            <AccountIcon className="userImage avatar-image__fallback" />
            {picture && status !== 'error' && <img
                ref={image}
                loading={loading}
                className="roundImage userImage avatar-image__photo"
                src={picture}
                alt=""
                onLoad={() => setStatus('loaded')}
                onError={() => setStatus('error')}
            />}
        </span>
    );
}

export default function UserImage({ picture, loading = 'lazy' }) {
    // A different source starts with the same placeholder, even if the previous image failed.
    return <AvatarImage key={picture || 'empty-avatar'} picture={picture} loading={loading} />;
}
